// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1QtZT","upload":"Small_upload__tJnEa","imageWrap":"Small_imageWrap__1yLy0","removeBtn":"Small_removeBtn__3dQzD"};